import React, { Component } from 'react'
import { connect } from 'react-redux'
import DocumentEvents from 'react-document-events'
import { throttle } from 'lodash'
import { scale } from 'utils/zoom'
import { getScreenBounds, getScreenOnCoordinates } from 'utils/editor.ts'
import { getXSnap, getYSnap } from 'ducks/editor/snapping'
import { getSnapGridParent, setSnapGridParent } from 'ducks/editor/selection'

import './SnapGrid.css'

class SnapGrid extends Component {
  constructor(props) {
    super(props)

    // TODO(enzo): tweak this, it does feel a bit laggy
    this.handleMouseMove = throttle(this.handleMouseMove, 250, {
      leading: true,
    })
  }

  handleMouseMove = e => {
    const { clientX, clientY } = e
    const { snapGridParent, setSnapGridParent } = this.props

    const pointerScreen = getScreenOnCoordinates(clientX, clientY)
    if (pointerScreen !== snapGridParent) {
      setSnapGridParent(pointerScreen)
    }
  }

  renderXSnap() {
    const { xSnap, zoom, snapGridParent } = this.props

    if (!xSnap || xSnap.coord === null || !snapGridParent) {
      return
    }

    const { coord } = xSnap

    const bounds = getScreenBounds(snapGridParent)

    let [x] = scale([coord, 0], zoom)
    x = Math.round(x + 0.5) - 0.5

    if (!bounds || x > bounds.right || x < bounds.left) {
      return
    }

    return (
      <line
        x1={x}
        x2={x}
        y1={bounds.top}
        y2={bounds.bottom}
        strokeDasharray="3 3"
        stroke="#f04b25"
      />
    )
  }

  renderYSnap() {
    const { ySnap, zoom, snapGridParent } = this.props

    if (!ySnap || ySnap.coord === null || !snapGridParent) {
      return
    }

    const bounds = getScreenBounds(snapGridParent)

    const { coord } = ySnap

    let [, y] = scale([0, coord], zoom)
    y = Math.round(y + 0.5) - 0.5

    if (!bounds || y < bounds.top || y > bounds.bottom) {
      return
    }

    const overflowPadding = 100 * zoom.scale
    const x1 = bounds.left - overflowPadding
    const x2 = bounds.right + overflowPadding
    const overflowPercent = overflowPadding / (bounds.right - bounds.left)
    const fadedColor = 'rgb(240, 75, 37, 0)'
    const solidColor = 'rgb(240, 75, 37, 1)'

    return (
      <>
        <defs>
          <linearGradient
            id="ySnapLine"
            x1={x1}
            y1={y}
            x2={x2}
            y2={y}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor={fadedColor} offset={0} />
            <stop stopColor={solidColor} offset={overflowPercent} />
            <stop stopColor={solidColor} offset={1 - overflowPercent} />
            <stop stopColor={fadedColor} offset={1} />
          </linearGradient>
        </defs>
        <line
          x1={x1}
          x2={x2}
          y1={y}
          y2={y}
          strokeDasharray="3 3"
          stroke="url(#ySnapLine)"
        />
      </>
    )
  }

  render() {
    return (
      <>
        <g className="snap-grid">
          {this.renderXSnap()}
          {this.renderYSnap()}
        </g>
        <DocumentEvents onMouseMove={this.handleMouseMove} />
      </>
    )
  }
}

const mapStateToProps = state => ({
  xSnap: getXSnap(state),
  ySnap: getYSnap(state),
  snapGridParent: getSnapGridParent(state),
})

export default connect(mapStateToProps, { setSnapGridParent })(SnapGrid)
